export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10480.9e6607c9.jpg";